import axios from 'axios'
import { BASEURL } from './api.variables'
import { getCookie } from '../helpers'
import { CreateUrlWithParams } from './helpers'

const SIGNUPURL = `${BASEURL}/signup`
const LOGINURL = `${BASEURL}/login`
const PROFILEURL = `${BASEURL}/profile?scope=profile`

const headers = () => {
  return {
    Authorization: document.redecienciaToken ? `Bearer ${document.redecienciaToken}` : `Bearer ${getCookie('redecienciaToken')}`
  }
}

const CreateUser = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: SIGNUPURL,
      data
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
      })
  })
}

const LoginUser = async (data) => {
  try {
    return await axios({
      method: 'post',
      url: LOGINURL,
      headers: headers(),
      data
    })
  } catch (error) {
    throw error
  }
  // return new Promise((resolve, reject) => {
  //   axios({
  //     method: 'post',
  //     url: LOGINURL,
  //     headers: headers(),
  //     data
  //   })
  //     .then(success => {
  //       createCookie('redecienciaToken', success.data.token, 7)
  //       document.redecienciaToken = success.data.token
  //       resolve(success)
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  // })
}

const GetUserProfile = (token) => {
  return new Promise((resolve, reject) => {
    let h = {}
    if (token) {
      h.Authorization = `Bearer ${token}`
    } else {
      h = { ...headers() }
    }
    axios({
      method: 'get',
      url: PROFILEURL,
      headers: h
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
        if (error.response.status === 403 || error.response.status === 401) {
          window.location.href = '/403'
        }
      })
  })
}

const ChangePassword = async (data) => {
  try {
    return await axios({
      method: 'patch',
      url: PROFILEURL,
      data,
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const GetUsers = async ({ params = {} }) => {
  try {
    return await axios({
      method: 'get',
      url: CreateUrlWithParams(`${BASEURL}/users`, { ...params }),
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const CreateModerator = async (data) => {
  try {
    return await axios({
      method: 'post',
      url: `${BASEURL}/users/moderators`,
      data,
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

const AdminChangePassword = async (userId, password) => {
  try {
    return await axios({
      method: 'patch',
      url: `${BASEURL}/users/${userId}/password`,
      data: { password },
      headers: headers()
    })
  } catch (error) {
    throw error
  }
}

export {
  CreateUser, LoginUser, GetUserProfile, GetUsers, ChangePassword, CreateModerator, AdminChangePassword
}



// WEBPACK FOOTER //
// ./src/api/user.js